const Layout = () => import('@/layout/index.vue')

export default  {
    meta: {
        title: '订单管理',
        icon: 'sidebar-default'
    },
    children: [{
        path: '/order',
        component: Layout,
        redirect: '/order/index',
        isLogin: false,
        meta: {
            title: '订单管理',
            icon: 'spgl',
            isShowIcon: true
        },
        children: [
            {
                path: 'index',
                name: 'OrderIndex',
                component: () => import('@/views/order/index.vue'),
                meta: {
                    title: '订单管理',
                    icon: 'merchant-account',
                    sidebar: false,
                    breadcrumb: false,
                    cache: ['OrderDeliver', 'OrderInfo', 'OrderLogistics']
                }
            },
            {
                path: 'deliver',
                name: 'OrderDeliver',
                component: () => import('@/views/order/deliver.vue'),
                meta: {
                    title: '订单发货',
                    icon: 'merchant-account',
                    sidebar: false,
                    breadcrumb: false
                }
            },
            {
                path: 'info',
                name: 'OrderInfo',
                component: () => import('@/views/order/info.vue'),
                meta: {
                    title: '订单详情',
                    icon: 'merchant-account',
                    sidebar: false,
                    breadcrumb: false
                }
            },
            {
                path: 'logistics',
                name: 'OrderLogistics',
                component: () => import('@/views/order/logistics.vue'),
                meta: {
                    title: '物流详情',
                    icon: 'merchant-account',
                    sidebar: false,
                    breadcrumb: false
                }
            }
        ]
    }]
}
